<ng-container>
  <input
    type="file"
    class="file-input"
    [accept]="requiredFileType"
    (change)="onFileSelected($event)"
    #fileUpload
  />

  <div class="file-preview" *ngIf="previewUrl">
    <a
      *ngIf="!fileName"
      target="_blank"
      [href]="previewUrl"
      class="text-blue-500"
      >{{ previewUrl?.split('/')?.pop() }}</a
    >

    <div
      class="attachment-wrapper"
      [ngClass]="{
        'cursor-default pointer-events-none': readonly,
        error: error
      }"
    >
      <div class="file-upload" (click)="fileUpload.click()">
        {{ fileName || ('common.upload-file' | translate) }}
        <vdr-icon name="upload"></vdr-icon>
      </div>
    </div>
  </div>

  <div
    class="attachment-wrapper"
    [ngClass]="{ 'cursor-default pointer-events-none': readonly, error: error }"
    *ngIf="!previewUrl"
  >
    <div class="file-upload" (click)="fileUpload.click()">
      {{ fileName || ('common.upload-file' | translate) }}
      <vdr-icon name="upload"></vdr-icon>
    </div>
  </div>
</ng-container>
